export enum DOM_EVENTS_ENUM {
  CLICK = 'click',
  INPUT = 'input'
}
